module.exports = __webpack_public_path__ + "img/itk-60x60.ea39ecaa.png";